<template>
    <div class="bg-0A1129">
        <div style="width:85%;margin:0 auto">
            <br /><br />
            <span class="custom-grey-badge mt-5">
                KATEGORI
            </span>

            <h4 class="custom-54px-600 text-white mt-3 mb-5">Ketahui bagaimana pelajar kami mencapai kejayaan baru dalam perjalanan peribadi dan akademik mereka.</h4>
      
            <br /><br />
            <CContainer>
                <CRow class="d-sm-down-none">
                <!-- First image - takes 8 columns -->
                <CCol md="8" class="mb-4">
    
                    <img :src="categories[0]" style="max-width:100%;height:400px" />
    
                </CCol>
                <!-- Second image - takes 4 columns -->
                <CCol md="4" class="mb-4">
    
                    <img :src="categories[1]" style="max-width:100%;height:350px" />
    
                </CCol>
                <!-- Second image - takes 4 columns -->
                <CCol md="5" class="mb-4">
    
                    <img :src="categories[2]" style="max-width:100%;height:350px" />
    
                </CCol>
                <CCol md="7" class="mb-4">
    
                    <img :src="categories[3]" style="max-width:100%;height:400px;border-radius:20px" />
    
                </CCol>
    
            </CRow>
            <CRow class="d-md-none d-lg-none">
                <!-- First image - takes 8 columns -->
                <CCol md="8" class="mb-4">
    
                    <img :src="categories[0]" style="max-width:100%;max-height:300px" />
    
                </CCol>
                <!-- Second image - takes 4 columns -->
                <CCol md="4" class="mb-4">
    
                    <img :src="categories[1]" style="max-width:100%;max-height:300px" />
    
                </CCol>
                <!-- Second image - takes 4 columns -->
                <CCol md="4" class="mb-4">
    
                    <img :src="categories[2]" style="max-width:100%;max-height:300px" />
    
                </CCol>
                <CCol md="8" class="mb-4">
    
                    <img :src="categories[3]" style="max-width:100%;max-height:300px;border-radius:20px" />
    
                </CCol>
    
            </CRow>

            </CContainer>
    
           
        </div>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            categories: [
                require('@/assets/img/flyhigh/c1.png'),
                require('@/assets/img/flyhigh/c2.png'),
                require('@/assets/img/flyhigh/c3.png'),
                require('@/assets/img/flyhigh/c4.png'),

            ]
        }
    }
}
</script>